<template>
  <div>
    <AverageReadinessBanner
      :averageReadiness="bannerAverageReadiness"
      :last_month_averageReadiness="last_month_averageReadiness"
      :loading="toggleLoader"
    />
    <div class="positions-readiness-tab">
      <PositionsReadinessTable
        :positions="positions"
        :filterGroups="filterGroups"
        :appliedFilters="appliedFilters"
        :searchText="searchText"
        :totalCount="totalCount"
        :currentPage="currentPage"
        :itemsPerPage="itemsPerPage"
        :toggleLoader="toggleLoader"
        :departments="departments"
        :departmentLoading="departmentLoading"
        :initialDepartment="initialDepartment"
        :initialScope="initialScope"
        @onChatterClick="handleChatterClick"
        @onSearch="handleSearch"
        @onFilterChange="handleFilterChange"
        @onRemoveFilter="handleRemoveFilter"
        @onClearFilters="handleClearFilters"
        @onExcludeChange="handleExcludeChange"
        @onPaginationChange="handlePaginationChange"
        @onPositionClick="handlePositionClick"
        @onDepartmentSearch="handleDepartmentSearch"
        @onDepartmentClear="handleDepartmentClear"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import PositionsReadinessTable from "@components/PositionsReadinessTable/PositionsReadinessTable.vue";
import AverageReadinessBanner from "@components/AverageReadinessBanner/AverageReadinessBanner.vue";

const props = defineProps({
  positions: {
    type: Array,
    default: () => [],
  },
  averageReadiness: {
    type: Number,
    default: 0,
  },
  positionsAverageReadiness: {
    type: Number,
    default: null,
  },
  last_month_averageReadiness: {
    type: [Number, null],
    default: null,
  },
  filterGroups: {
    type: Array,
    default: () => [],
  },
  appliedFilters: {
    type: Array,
    default: () => [],
  },
  searchText: {
    type: String,
    default: "",
  },
  totalCount: {
    type: Number,
    default: 0,
  },
  currentPage: {
    type: Number,
    default: 1,
  },
  itemsPerPage: {
    type: Number,
    default: 10,
  },
  toggleLoader: {
    type: Boolean,
    default: false,
  },
  departments: {
    type: Array,
    default: () => [],
  },
  departmentLoading: {
    type: Boolean,
    default: false,
  },
  initialDepartment: {
    type: Object,
    default: null,
  },
  initialScope: {
    type: String,
    default: "subtree",
  },
});

const bannerAverageReadiness = computed(() =>
  props.positionsAverageReadiness !== null && props.positionsAverageReadiness !== undefined
    ? props.positionsAverageReadiness
    : props.averageReadiness
);

const emit = defineEmits([
  "onChatterClick",
  "onSearch",
  "onFilterChange",
  "onRemoveFilter",
  "onClearFilters",
  "onExcludeChange",
  "onPaginationChange",
  "onPositionClick",
  "onDepartmentSearch",
  "onDepartmentClear",
]);

const handleChatterClick = (position) => {
  emit("onChatterClick", position);
};

const handleSearch = (text) => {
  emit("onSearch", text);
};

const handleFilterChange = (filters) => {
  emit("onFilterChange", filters);
};

const handleRemoveFilter = (filter) => {
  emit("onRemoveFilter", filter);
};

const handleClearFilters = () => {
  emit("onClearFilters");
};

const handleExcludeChange = (data) => {
  emit("onExcludeChange", data);
};

const handlePaginationChange = (data) => {
  emit("onPaginationChange", data);
};

const handlePositionClick = (data) => {
  emit("onPositionClick", data);
};

const handleDepartmentSearch = (query) => {
  emit("onDepartmentSearch", query);
};

const handleDepartmentClear = () => {
  emit("onDepartmentClear");
};
</script>

<style scoped>
.positions-readiness-tab {
  margin-top: 15px;
  margin-bottom: 15px;
  padding-bottom: 100px;
}
</style>
